import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserLastName: Getter<UserState, RootState> = (state) =>
  state.current?.last_name || ''

export default getUserLastName
